import styled from 'styled-components';

export const ScatterPlotWidgetGraphStyled = styled.div`
  width: 100%;
  height: 100%;

  .am5-html-container {
    overflow: visible !important;
  }
`;
